/* ============================================================================
   Ypersoa — Module 2 : Drawer customizer (state machine)
   Slide drawer de personnalisation + ATC AJAX. Vanilla ES6, sans dépendance.
   Sélecteurs défensifs : élément manquant = warning console [Ypersoa], pas de crash.
   ========================================================================== */
(function () {
  'use strict';

  var LOG = '[Ypersoa]';
  var ADDON_PRICE_CENTS = 600;

  /* Vocabulaire interdit côté texte brodé client (cf. règle de marque). */
  var FORBIDDEN = [
    /\bfait[\s-]?main\b/,
    /\bbrod\w*\s+main\b/,
    /\ba\s+la\s+main\b/,
    /\bartisan\w*\s+brod\w+/
  ];

  var DIACRITICS = new RegExp('[\\u0300-\\u036f]', 'g'); // marques diacritiques combinantes
  function normalize(str) {
    return (str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(DIACRITICS, ''); // à→a, é→e…
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return amount.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function YpersoaCustomizerDrawer(root) {
    this.root = root;
    this.handle = root.dataset.handle || '';
    this.motif = root.dataset.motif || '';
    this.addonHandle = root.dataset.addonHandle || 'poignet-addon';
    this.basePrice = parseInt(root.dataset.basePrice, 10) || 0;
    this.currentVariantId = root.dataset.defaultVariant || '';
    this.addonVariantId = null;
    this.opener = null;
    this.prevOverflow = '';

    this.panel = root.querySelector('.yps-drawer__panel');
    this.textInput = root.querySelector('[data-yps-text]');
    this.counter = root.querySelector('[data-yps-counter]');
    this.addonInput = root.querySelector('[data-yps-addon]');
    this.submitBtn = root.querySelector('[data-yps-submit]');
    this.spinner = root.querySelector('[data-yps-spinner]');
    this.errorEl = root.querySelector('[data-yps-error]');
    this.recapFil = root.querySelector('[data-yps-recap-fil]');
    this.recapTotal = root.querySelector('[data-yps-recap-total]');
    this.filNameLabel = root.querySelector('[data-yps-fil-name]');
    this.stickybarPrice = document.querySelector('[data-yps-stickybar-price]'); // barre CTA (hors root)

    if (!this.panel) { console.warn(LOG, 'panneau drawer introuvable — drawer désactivé.'); return; }

    this._variantPrices = this._buildVariantPriceMap();
    this._bind();
    this._resolveAddon();
    this._refreshRecap();
  }

  /* Map variantId → prix, depuis le product JSON s'il est présent. */
  YpersoaCustomizerDrawer.prototype._buildVariantPriceMap = function () {
    var map = {};
    var node = document.querySelector('[data-product-json]');
    if (!node) return map;
    try {
      var product = JSON.parse(node.textContent);
      (product.variants || []).forEach(function (v) { map[String(v.id)] = v.price; });
    } catch (e) {
      console.warn(LOG, 'product JSON illisible pour la map des prix.', e);
    }
    return map;
  };

  YpersoaCustomizerDrawer.prototype._bind = function () {
    var self = this;

    /* Ouverture via le CTA principal (délégué). */
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-yps-drawer-open]');
      if (!opener) return;
      e.preventDefault();
      self.open(opener);
    });

    /* Fermetures : backdrop, bouton close. */
    this.root.querySelectorAll('[data-yps-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.close(); });
    });

    /* Escape + trap focus. */
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { self.close(); return; }
      if (e.key === 'Tab') self._trapFocus(e);
    });

    /* Compteur de texte. */
    if (this.textInput && this.counter) {
      var max = this.textInput.maxLength > 0 ? this.textInput.maxLength : 12;
      this.textInput.addEventListener('input', function () {
        self.counter.textContent = self.textInput.value.length + ' / ' + max;
        self.counter.classList.toggle('is-max', self.textInput.value.length >= max);
        self._clearError();
      });
    }

    /* Couleur de fil → label + récap. */
    this.root.querySelectorAll('[data-yps-fil]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        if (self.filNameLabel) self.filNameLabel.textContent = radio.value;
        self._refreshRecap();
      });
    });

    /* Toggle add-on → recalcul total. */
    if (this.addonInput) {
      this.addonInput.addEventListener('change', function () { self._refreshRecap(); });
    }

    /* Soumission. */
    if (this.submitBtn) {
      this.submitBtn.addEventListener('click', function () { self.submit(); });
    }

    /* Mise à jour du variant courant (taille) depuis le form principal. */
    var onVariant = function (e) {
      var variant = e.detail && (e.detail.id ? e.detail : e.detail.variant);
      if (variant && variant.id) {
        self.currentVariantId = String(variant.id);
        if (typeof variant.price === 'number') self.basePrice = variant.price;
        else if (self._variantPrices[self.currentVariantId] != null) self.basePrice = self._variantPrices[self.currentVariantId];
        if (self.stickybarPrice) self.stickybarPrice.textContent = formatMoney(self.basePrice);
        self._refreshRecap();
      }
    };
    document.addEventListener('ypersoa:variant-change', onVariant);
    document.addEventListener('variant:change', onVariant);
  };

  /* Récupère le variant ID courant : event reçu, sinon hidden input du form. */
  YpersoaCustomizerDrawer.prototype._readCurrentVariantId = function () {
    var form = document.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput && idInput.value) return idInput.value;
    return this.currentVariantId;
  };

  /* Résolution du variant add-on poignet par handle (préchargement). */
  YpersoaCustomizerDrawer.prototype._resolveAddon = function () {
    var self = this;
    fetch('/products/' + this.addonHandle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('GET /products/' + self.addonHandle + '.js → ' + r.status);
        return r.json();
      })
      .then(function (product) {
        self.addonVariantId = product.variants[0].id;
      })
      .catch(function (err) {
        console.warn(LOG, 'add-on poignet introuvable (handle "' + self.addonHandle + '") — option désactivée.', err.message);
        self._disableAddon();
      });
  };

  YpersoaCustomizerDrawer.prototype._disableAddon = function () {
    if (!this.addonInput) return;
    this.addonInput.checked = false;
    this.addonInput.disabled = true;
    var label = this.addonInput.closest('.yps-addon');
    if (label) label.classList.add('yps-addon__disabled');
    this._refreshRecap();
  };

  /* ── État ouvert / fermé ──────────────────────────────────────────────── */
  YpersoaCustomizerDrawer.prototype.open = function (opener) {
    this.opener = opener || document.activeElement;
    this.root.hidden = false;
    this.root.setAttribute('aria-hidden', 'false');
    /* reflow avant transition */
    void this.root.offsetWidth;
    this.root.classList.add('is-open');

    this.prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';

    var self = this;
    window.setTimeout(function () {
      if (self.textInput) self.textInput.focus();
      else if (self.panel) self.panel.focus();
    }, 60);
  };

  YpersoaCustomizerDrawer.prototype.close = function () {
    if (this.root.hidden) return;
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = this.prevOverflow;

    var self = this;
    var done = function () {
      self.root.hidden = true;
      self.panel.removeEventListener('transitionend', done);
    };
    this.panel.addEventListener('transitionend', done);
    /* fallback si pas de transitionend (reduced-motion) */
    window.setTimeout(done, 400);

    if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
  };

  YpersoaCustomizerDrawer.prototype._trapFocus = function (e) {
    var focusables = this.panel.querySelectorAll(
      'button, [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var list = Array.prototype.filter.call(focusables, function (el) { return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* ── Récap live ───────────────────────────────────────────────────────── */
  YpersoaCustomizerDrawer.prototype._selectedFil = function () {
    var checked = this.root.querySelector('[data-yps-fil]:checked');
    return checked ? checked.value : '';
  };

  YpersoaCustomizerDrawer.prototype._total = function () {
    var total = this.basePrice;
    if (this.addonInput && this.addonInput.checked && !this.addonInput.disabled) total += ADDON_PRICE_CENTS;
    return total;
  };

  YpersoaCustomizerDrawer.prototype._refreshRecap = function () {
    if (this.recapFil) this.recapFil.textContent = this._selectedFil();
    if (this.recapTotal) this.recapTotal.textContent = formatMoney(this._total());
  };

  /* ── Brand safety ─────────────────────────────────────────────────────── */
  YpersoaCustomizerDrawer.prototype.checkBrandSafety = function (text) {
    var norm = normalize(text);
    return !FORBIDDEN.some(function (re) { return re.test(norm); });
  };

  /* ── Erreurs ──────────────────────────────────────────────────────────── */
  YpersoaCustomizerDrawer.prototype._showError = function (msg) {
    if (!this.errorEl) { console.warn(LOG, msg); return; }
    this.errorEl.textContent = msg;
    this.errorEl.hidden = false;
  };
  YpersoaCustomizerDrawer.prototype._clearError = function () {
    if (this.errorEl) { this.errorEl.hidden = true; this.errorEl.textContent = ''; }
  };

  /* ── ATC ──────────────────────────────────────────────────────────────── */
  YpersoaCustomizerDrawer.prototype._setBusy = function (busy) {
    if (this.submitBtn) this.submitBtn.setAttribute('aria-busy', String(busy));
    if (this.spinner) this.spinner.hidden = !busy;
  };

  YpersoaCustomizerDrawer.prototype.submit = function () {
    this._clearError();

    var text = (this.textInput ? this.textInput.value : '').trim();
    if (!text) {
      this._showError('Écris d’abord ton texte à broder.');
      if (this.textInput) this.textInput.focus();
      return;
    }
    if (!this.checkBrandSafety(text)) {
      this._showError('Ce texte ne peut pas être brodé : toutes nos broderies sont réalisées à la commande dans notre atelier de Wattrelos. Choisis un autre texte.');
      if (this.textInput) this.textInput.focus();
      return;
    }

    var variantId = this._readCurrentVariantId();
    if (!variantId) { this._showError('Sélectionne d’abord une taille.'); return; }

    var fil = this._selectedFil();
    var items = [{
      id: variantId,
      quantity: 1,
      properties: { 'Texte brodé': text, 'Couleur fil': fil, 'Motif': this.motif || '' }
    }];

    var addonActive = this.addonInput && this.addonInput.checked && !this.addonInput.disabled && this.addonVariantId;
    if (addonActive) {
      items.push({
        id: this.addonVariantId,
        quantity: 1,
        properties: { '_parent': this.handle, 'Texte brodé': text, 'Couleur fil': fil }
      });
    }

    this._setBusy(true);

    var self = this;
    var sections = this._cartSections();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Erreur ajout au panier.');
        document.dispatchEvent(new CustomEvent('ypersoa:add-to-cart', { detail: data }));
        self._afterAdd(data);
      })
      .catch(function (err) {
        console.error(LOG, err);
        self._showError('L’ajout au panier a échoué. Vérifie ta connexion et réessaie.');
      })
      .finally(function () { self._setBusy(false); });
  };

  /* Liste des sections à rafraîchir (cart drawer + bulle panier), si présentes. */
  YpersoaCustomizerDrawer.prototype._cartSections = function () {
    var names = [];
    var drawer = document.querySelector('cart-drawer');
    var section = drawer && drawer.closest('.shopify-section');
    if (section && section.id) names.push(section.id.replace('shopify-section-', ''));
    var bubble = document.querySelector('#cart-icon-bubble, [id^="cart-icon"]');
    var bubbleSection = bubble && bubble.closest('.shopify-section');
    if (bubbleSection && bubbleSection.id) names.push(bubbleSection.id.replace('shopify-section-', ''));
    return names;
  };

  /* Succès : ouvre le cart drawer Inova si détecté, sinon redirige /cart.
     Mirroir du pattern natif (theme.js) : on attache les sections HTML rendues
     par /cart/add.js au cart JSON avant de publier cartUpdate. */
  YpersoaCustomizerDrawer.prototype._afterAdd = function (addData) {
    var drawer = document.querySelector('cart-drawer');
    var pubsub = window.theme && window.theme.pubsub;

    if (drawer && pubsub && pubsub.publish && pubsub.PUB_SUB_EVENTS) {
      var self = this;
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (addData && addData.sections) cart.sections = addData.sections;
          pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'ypersoa-customizer', cart: cart });
          self.close();
          if (typeof drawer.show === 'function') drawer.show();
          else drawer.setAttribute('open', '');
        })
        .catch(function () { window.location.href = '/cart'; });
      return;
    }

    window.location.href = '/cart';
  };

  /* ── Boot ─────────────────────────────────────────────────────────────── */
  function boot() {
    document.querySelectorAll('[data-yps-drawer]').forEach(function (el) {
      new YpersoaCustomizerDrawer(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.YpersoaCustomizerDrawer = YpersoaCustomizerDrawer;
})();
